import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'
import styles from './EntriModal.module.css'

const EntriModal = ({ show, onHide, entriIframeConfig, onManualSetup }) => {
  const [showManualBtn, setShowManualBtn] = useState(false)

  useEffect(() => {
    if (show) {
      setShowManualBtn(false)
      const timer = setTimeout(() => {
        setShowManualBtn(true)
      }, 5000)
      return () => clearTimeout(timer)
    } else {
      setShowManualBtn(false)
    }
  }, [show])

  const handleAlternativeSetup = () => {
    onHide()
    const loadEntri = () => {
      if (window.entri && typeof window.entri.showEntri === 'function') {
        window.entri.showEntri(entriIframeConfig)
      }
    }
    if (!document.getElementById('entri-script')) {
      const script = document.createElement('script')
      script.id = 'entri-script'
      script.src = 'https://cdn.goentri.com/entri.js'
      script.onload = loadEntri
      document.body.appendChild(script)
    } else {
      loadEntri()
    }
  }

  useEffect(() => {
    const handleMessage = (e) => {
      if (e.data?.type === 'ENTRI_ALTERNATIVE_SETUP') {
        handleAlternativeSetup()
      }
    }
    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [entriIframeConfig, onHide])

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      contentClassName="border-0 bg-transparent shadow-none"
    >
      <Modal.Body className="p-0 d-flex flex-column align-items-center">
        {entriIframeConfig && (
          <iframe
            srcDoc={`
              <!DOCTYPE html>
              <html>
                <head>
                  <meta charset="utf-8">
                  <meta name="viewport" content="width=device-width, initial-scale=1">
                  <script src="https://cdn.goentri.com/entri.js"></script>
                  <style>
                    body { margin: 0; padding: 0; overflow: hidden; background: transparent; }
                    /* Attempt to make Entri fill the iframe and hide its grey backdrop */
                    #entri-container { display: flex; justify-content: center; align-items: center; height: 100vh; position: relative; }
                    #loading-ui {
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      color: #6b7280;
                      font-size: 16px;
                      font-family: sans-serif;
                      font-weight: 500;
                      text-align: center;
                      width: 100%;
                    }
                    #loading-ui a {
                      color: #0d6efd;
                      cursor: pointer;
                      text-decoration: underline;
                      font-size: 14px;
                      margin-left: 5px;
                    }
                  </style>
                </head>
                <body>
                  <div id="loading-ui">
                    Loading Entri…
                    <span id="fallback-link" style="display: none;">
                      <a onclick="window.parent.postMessage({ type: 'ENTRI_ALTERNATIVE_SETUP' }, '*'); return false;">Having problem loading? Click here</a>
                    </span>
                  </div>
                  <div id="entri-container" style="width: 100%; height: 100vh;"></div>
                  <script>
                    const config = ${JSON.stringify(entriIframeConfig)};
                    const loadEntri = () => {
                      if (window.entri && typeof window.entri.showEntri === 'function') {
                        const loadingUi = document.getElementById('loading-ui');
                        if (loadingUi) loadingUi.style.display = 'none';
                        window.entri.showEntri(config);
                      }
                    };
                    setTimeout(() => {
                      const fallback = document.getElementById('fallback-link');
                      if (fallback) fallback.style.display = 'inline';
                    }, 5000);
                    window.addEventListener('entri:ready', loadEntri);
                    setTimeout(loadEntri, 500); // Fallback in case event is missed
                    window.addEventListener('onEntriClose', (e) => {
                       window.parent.postMessage({ type: 'ENTRI_CLOSE', detail: e.detail }, '*');
                    });
                  </script>
                </body>
              </html>
            `}
            className={styles.iframe}
            title="Entri DNS Setup"
          />
        )}
        {showManualBtn && (
          <div className={`d-flex justify-content-center p-3 w-100 ${styles.buttonContainer}`}>
            <Button variant="outline-secondary" className="rounded-pill px-4 w-100" onClick={onManualSetup}>
              Add manually instead
            </Button>
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default EntriModal
